import { ShoppingCartThemeModeConfig } from './types';

const light: ShoppingCartThemeModeConfig = {
  shoppingCart: {
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default light;
